<template>
    <div class="account">
        <!-- 采购的需方 -->
        <vFlowNegativeListComponent :postList="postList" v-if="flag"></vFlowNegativeListComponent>
    </div>
</template>
<script>
import vFlowNegativeListComponent from '../../listComponent/basicdata/flowSourceLists/flowNegativeListComponent.vue';
export default {
    name: 'flowNegativeList',
    components: {
        vFlowNegativeListComponent
    },
    data() {
        return {
            postList: {
                headerTitle: true,
                source_file: true,
                rid: true,
                business_rid: true,
                product_rid: true,
                demander_rid: true,
                product_batch_number: true,
                batchPendingBtn: true,
                batchWriteoffBtn: true,
                batchProcessBtn: true,
                searchBtn: true,
                resetBtn: true,
                setBtn: true
            },
            flag: false
        };
    },
    mounted() {
        this.flag = false;
        this.$nextTick(() => {
            this.flag = true;
        });
    },
    methods: {}
};
</script>
<style lang="scss" scoped="scoped">
</style>